import React from 'react';
import { usePlaytesterStore } from '../../stores/playtester-store.js';

interface ColButtonProps {
  label: string;
  shortcut: string;
  onClick: () => void;
  danger?: boolean;
}

function ColButton({ label, shortcut, onClick, danger }: ColButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`relative w-full py-2 px-1 text-xs font-medium rounded transition flex flex-col items-center gap-0.5 border ${
        danger
          ? 'border-red-900/50 text-red-400 bg-gray-900 hover:bg-red-950/40'
          : 'border-gray-800 text-gray-300 bg-gray-900 hover:bg-gray-800 hover:text-white'
      }`}
    >
      <span className="leading-tight text-center">{label}</span>
      <span className="text-[9px] text-gray-600 font-mono leading-none">[{shortcut}]</span>
    </button>
  );
}

export default function PlaytesterButtonColumn() {
  const restart = usePlaytesterStore((s) => s.restart);
  const setOpenPanel = usePlaytesterStore((s) => s.setOpenPanel);
  const shuffleLibrary = usePlaytesterStore((s) => s.shuffleLibrary);
  const drawCard = usePlaytesterStore((s) => s.drawCard);
  const nextTurn = usePlaytesterStore((s) => s.nextTurn);

  // Phase 2: Horde phase-specific actions
  const horde = usePlaytesterStore((s) => s.horde);
  const endSetupTurn = usePlaytesterStore((s) => s.endSetupTurn);
  const endPlayerTurn = usePlaytesterStore((s) => s.endPlayerTurn);
  const beginMyTurn = usePlaytesterStore((s) => s.beginMyTurn);

  return (
    <div className="shrink-0 w-16 bg-gray-900/50 border-l border-gray-800 flex flex-col gap-1.5 p-1.5 overflow-y-auto">
      <ColButton
        label="Restart"
        shortcut="R"
        onClick={restart}
        danger
      />
      <ColButton
        label="Add Token"
        shortcut="A"
        onClick={() => setOpenPanel('token')}
      />
      <ColButton
        label="Shuffle"
        shortcut="S"
        onClick={shuffleLibrary}
      />
      <ColButton
        label="Library"
        shortcut="V"
        onClick={() => setOpenPanel('library')}
      />
      <ColButton
        label="Draw"
        shortcut="D"
        onClick={drawCard}
      />

      {/* Phase 1: Next Turn (only when not in horde mode) */}
      {!horde && (
        <ColButton
          label="Next Turn"
          shortcut="N"
          onClick={nextTurn}
        />
      )}

      {/* Phase 2: Horde phase buttons */}
      {horde?.phase === 'setup' && (
        <ColButton
          label={horde.setupTurn >= 3 ? 'End Setup — Begin Horde' : 'End Setup Turn'}
          shortcut="N"
          onClick={endSetupTurn}
        />
      )}
      {horde?.phase === 'player-turn' && (
        <ColButton
          label="End Turn"
          shortcut="N"
          onClick={endPlayerTurn}
        />
      )}
      {horde?.phase === 'horde-resolving' && (
        <ColButton
          label="Begin My Turn"
          shortcut="N"
          onClick={beginMyTurn}
        />
      )}
    </div>
  );
}
